"use client";
import {
  Calendar,
  CreditCard,
  LayoutDashboard,
  Mail,
  // MessageSquare,
  // PlayCircle,
  // PlusCircle,
  Rocket,
  // Share2,
  Users,
  Video,
  ArrowRight,
} from "lucide-react";

import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/shadcnComponents/ui/sidebar";
import { useNavigate } from "react-router-dom";
import mixpanel from "mixpanel-browser";
import { useAuth } from "@/Providers/Auth";
import { CreateNewCampaign } from "../Sidebar/Sidebar";

export const platformItems = [
  {
    title: "Dashboard",
    icon: LayoutDashboard,
    url: "/Brand/DashBoard",
    status: 1,
  },
  // {
  //   title: "Live Campaign",
  //   icon: PlayCircle,
  //   url: "/live-campaign",
  // },
  {
    title: "All Campaign",
    icon: Video,
    url: "/Brand/DashBoard/AllCampaign",
    status: 1,
  },
  {
    title: "Calendar",
    icon: Calendar,
    url: "/Brand/DashBoard/Calendar",
    status: 0,
  },
  {
    title: "Payment History",
    icon: CreditCard,
    url: "/Brand/DashBoard/PaymentHistory",
    status: 1,
  },
  // {
  //   title: "Feedback",
  //   icon: MessageSquare,
  //   url: "/Brand/DashBoard",
  // },
  // {
  //   title: "Referral",
  //   icon: Share2,
  //   url: "/Brand/DashBoard",
  // },
  {
    title: "Pricing",
    icon: CreditCard,
    url: "/Brand/DashBoard/pricing",
    status: 0,
  },
];

export function NavMain() {
  const navigate = useNavigate();
  const authState = useAuth();
  const creditItems = [
    {
      name: "Campaigns Left",
      value: authState?.loggedBrand?.creditStats?.find(
        (item) => item?.type === "Campaigns"
      )?.available,
      icon: Mail,
    },
    {
      name: "Anchors Credits",
      value: authState?.loggedBrand?.creditStats?.find(
        (item) => item?.type === "anchor Credits"
      )?.available,
      icon: CreditCard,
    },
    {
      name: "Collaboration Credits",
      value: authState?.loggedBrand?.creditStats?.find(
        (item) => item?.type === "Collaborations"
      )?.available,
      icon: Users,
    },
  ];
  const latestCampaignItems = authState?.loggedBrand?.latestCampaigns?.map(
    (item) => {
      return {
        title: item.title,
        icon: Rocket,
        url:
          item?.status === 1
            ? `${window.location.origin}/Brand/Dashboard/AllCampaign/Campaign/${item.id}`
            : `${window.location.origin}/Brand/Dashboard/AllCampaign/Draft/${item.id}`,
      };
    }
  );
  return (
    <>
      <SidebarGroup>
        <div className="px-4 py-2 mb-4 flex flex-col gap-1 items-center justify-center ">
          <div className="flex gap-1 mb-5 items-center ">
            <img
              src={
                "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/brand-logo-BwAxsepq%5B1%5D%20(1)-JunPyjnSrXhN6ca8y4RQ7u64I33zMv.png"
              }
              alt=""
              className="w-32  cursor-pointer"
              onClick={() => {
                navigate("/Brand");
              }}
            />
            <BrandNotificationPanel />
          </div>
          <CreateNewCampaign />
        </div>
        <SidebarGroupLabel>Platform</SidebarGroupLabel>
        <SidebarMenu>
          {platformItems
            ?.filter((item) => item?.status)
            .map((item) => (
              <SidebarMenuItem key={item?.title}>
                <SidebarMenuButton
                  asChild
                  isActive={item?.url === location.pathname}
                  className="gap-3 cursor-pointer "
                  tooltip={item?.title}
                >
                  <span
                    onClick={() => {
                      mixpanel.track("Sidebar: Payment History - clicked");
                      navigate(item?.url);
                    }}
                  >
                    <item.icon className="h-4 w-4" />
                    <span>{item?.title}</span>
                  </span>
                </SidebarMenuButton>
              </SidebarMenuItem>
            ))}
        </SidebarMenu>
      </SidebarGroup>
      <SidebarGroup>
        <SidebarGroupLabel>Latest Campaign</SidebarGroupLabel>
        <SidebarMenu>
          {latestCampaignItems?.map((item) => (
            <SidebarMenuItem key={item?.title}>
              <SidebarMenuButton asChild className="gap-3">
                <a href={item?.url}>
                  <item.icon className="h-4 w-4" />
                  <span>{item?.title}</span>
                </a>
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarGroup>
      <SidebarGroup>
        <SidebarGroupLabel asChild>
          <a
            href="/Brand/DashBoard/PaymentHistory"
            className="flex items-center justify-between hover:text-primary"
          >
            Available Credits
            <ArrowRight className="h-4 w-4" />
          </a>
        </SidebarGroupLabel>
        <SidebarMenu>
          {creditItems?.map((item) => (
            <SidebarMenuItem key={item?.name}>
              <SidebarMenuButton className="gap-3">
                <item.icon className="h-4 w-4" />
                <span>{item?.name}</span>
                <span className="ml-auto font-mono text-xs">{item?.value}</span>
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarGroup>
      <PlanExpiryDetails
        planData={{
          planName: authState?.loggedBrand?.planName,
          planExpiry: authState?.loggedBrand?.planExpiry,
          daysRemaining: dateDifference(
            new Date(Date.now()),
            new Date(authState?.loggedBrand?.planExpiry)
          )?.days,
          isActive: authState?.loggedBrand?.activePlan,
        }}
      />
    </>
  );
}

import { Clock, AlertTriangle } from "lucide-react";
import { dateDifference } from "@/Helpers/times-ago";
import { BrandNotificationPanel } from "../Notification/notification-panel";

// This component shows plan details with visual status indicators
const PlanExpiryDetails = ({ planData }) => {
  // Destructure plan data with defaults
  const {
    planName,
    planExpiry,
    daysRemaining = 0,
    isActive = true,
  } = planData || {};

  // Calculate status for visual indication
  const getStatusInfo = () => {
    if (!isActive)
      return {
        color: "text-red-500",
        icon: <AlertTriangle className="h-4 w-4" />,
        message: "Expired",
      };
    if (daysRemaining <= 3)
      return {
        color: "text-amber-500",
        icon: <AlertTriangle className="h-4 w-4" />,
        message: "Expiring Soon",
      };
    // if (daysRemaining <= 7)
    //   return {
    //     color: "text-amber-400",
    //     icon: <Clock className="h-4 w-4" />,
    //     message: "Upcoming Renewal",
    //   };
    return {
      color: "text-green-500",
      icon: <Clock className="h-4 w-4" />,
      message: "Active",
    };
  };

  const { color, icon, message } = getStatusInfo();

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return "No expiry date";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  return (
    <SidebarGroup>
      <SidebarGroupLabel asChild>
        <a
          href="/Brand/Dashboard/PaymentHistory"
          className="flex items-center justify-between hover:text-primary"
        >
          <span className="flex items-center gap-2">
            <CreditCard className="h-4 w-4" />
            Subscription Details
          </span>
        </a>
      </SidebarGroupLabel>
      <SidebarMenu>
        <SidebarMenuItem>
          <SidebarMenuButton className="w-full h-auto ">
            <div className="w-full space-y-2 py-1">
              {/* Plan name and status */}
              <div className="flex items-center justify-between">
                {planName && <span className="font-medium">{planName}</span>}
                <span className={`flex items-center gap-1 text-xs ${color}`}>
                  {icon}
                  {message}
                </span>
              </div>

              {/* Expiry date with calendar icon */}
              {planExpiry && (
                <div className="flex items-center gap-2 text-xs text-gray-500">
                  <Calendar className="h-3 w-3" />
                  <span>Expires: {formatDate(planExpiry)}</span>
                </div>
              )}

              {/* Days remaining counter */}
              {isActive && (
                <div className={`mt-1 text-xs font-medium ${color}`}>
                  {daysRemaining > 0
                    ? `${daysRemaining} day${
                        daysRemaining !== 1 ? "s" : ""
                      } remaining`
                    : "Expires today"}
                </div>
              )}

              {/* Call to action */}
              {/* {(!isActive || daysRemaining <= 7) && (
                <a
                  href="/Brand/Dashboard/Billing"
                  className="mt-2 block w-full rounded bg-primary py-1 text-center text-xs text-white hover:bg-primary/90"
                >
                  {isActive ? "Renew Subscription" : "Reactivate Plan"}
                </a>
              )} */}
            </div>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarGroup>
  );
};
